import React, { useState, useEffect } from 'react'
import {Navbar, Container, Nav} from 'react-bootstrap'
import { Link, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from '../firebase-config';

export default function Header() {
    const navigate = useNavigate();
    const [user, setUser] = useState();

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            setUser(user)
        });
    }, [])

    const logOut = () => {
        signOut(auth).then(() => {
            navigate('/', { replace: false });
        }).catch((error) => {
            console.log('error');
        });
    }

  return (
    <>
        <Container>
            <h1 className='text-center display-3'>
            Smt. Ganga Devi Inter College
            </h1>
            <h4 className='text-center pb-2 lead'>
            Village Petha, Goverdhan Tehsil, Mathura -
            <code className="highlighter-rouge">281502</code>
            </h4>
        </Container>
        <Navbar bg="dark" variant="dark" sticky="top">
            <Container>
                <Link to="/" className='navbar-brand'>Home</Link>
                <Navbar.Collapse id="basic-navbar-nav">
                    {/* <Nav.Link href="#notices">Notices</Nav.Link> */}
                    {/* <Nav.Link href="#notices">Facilities</Nav.Link> */}
                    {/* <Nav.Link href="#gallary">Gallary</Nav.Link> */}
                    <Link to="/contact" className='nav-link'>Contact Us</Link>
                    <Link to="/about" className='nav-link'>About Us</Link>
                    {user?.email && 
                        <Nav.Link onClick={logOut}>Logout</Nav.Link>
                    }
                    {!user?.email &&
                        <Link to="/login" className='nav-link'>Login</Link>
                    }
                </Navbar.Collapse>
            </Container>
        </Navbar>
        {user?.email && 
            <span>{ user?.email }</span>
        }
    </>
  )
}
